import * as React from 'react';
import { Asset } from '../../../../../../../../services/asset/types/asset';

import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from '@material-ui/icons/CloudDownload';

interface TrackFileInfoProps {
  asset: Asset
}

const formatSize = (size: number) => {
  return `${ (size / 1024 / 1024).toFixed(1) }mb`;
}

export const TrackFileInfo: React.FC<TrackFileInfoProps> = (props) => {

  const {asset} = props;

  return (
      <p>
        <IconButton onClick={() => window.open(asset.url)}>
          <DownloadIcon />
        </IconButton>
        { asset.contentType } | { formatSize(asset.size) }
      </p>
  )
}